import { Bell, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';

export function NotificationsTab({ notifications, handleMarkAllRead, handleDeleteAllNotifications, handleMarkNotificationRead, handleDeleteNotification }) {
  return (
    <div className="bg-surface border border-[#262626] rounded-xl">
      {notifications.length === 0 ? (
        <div className="text-center py-16">
          <Bell className="w-16 h-16 mx-auto mb-4 text-[#333]" />
          <h3 className="text-xl font-heading font-bold mb-2">No Notifications</h3>
          <p className="text-[#A1A1AA]">You&apos;re all caught up!</p>
        </div>
      ) : (
        <>
          <div className="p-4 border-b border-[#262626] flex justify-between items-center">
            <span className="text-sm text-[#A1A1AA]">{notifications.filter(n => !n.is_read).length} unread</span>
            <div className="flex gap-2">
              <Button onClick={handleMarkAllRead} variant="ghost" size="sm" className="text-sm text-lime hover:text-lime-dark" data-testid="mark-all-read">Mark all as read</Button>
              <Button onClick={handleDeleteAllNotifications} variant="ghost" size="sm" className="text-sm text-red-400 hover:text-red-300 hover:bg-red-400/10" data-testid="delete-all-notifications"><Trash2 className="w-3 h-3 mr-1" />Clear All</Button>
            </div>
          </div>
          <div className="divide-y divide-[#262626]">
            {notifications.map((notification) => (
              <div key={notification.id} className={`p-4 cursor-pointer ${!notification.is_read ? 'bg-lime/5' : ''}`} onClick={() => !notification.is_read && handleMarkNotificationRead(notification.id)} data-testid={`notification-${notification.id}`}>
                <div className="flex items-start gap-3">
                  <div className={`w-2 h-2 rounded-full mt-2 ${!notification.is_read ? 'bg-lime' : 'bg-[#333]'}`} />
                  <div className="flex-1">
                    <h4 className="font-medium mb-1">{notification.title}</h4>
                    <p className="text-sm text-[#A1A1AA]">{notification.message}</p>
                    <p className="text-xs text-[#666] mt-2">{new Date(notification.created_at).toLocaleString()}</p>
                  </div>
                  <Button variant="ghost" size="icon" className="text-[#555] hover:text-red-400 hover:bg-red-400/10 flex-shrink-0 h-8 w-8" onClick={(e) => handleDeleteNotification(e, notification.id)} data-testid={`delete-notification-${notification.id}`}><Trash2 className="w-3.5 h-3.5" /></Button>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
